import { jsxs as m, jsx as l } from "react/jsx-runtime";
import { c as p } from "../../index-C3-ZVs5E.js";
import '../../assets/InputLabelWrapper.css';const i = "_label_1ubaj_2", d = "_error_1ubaj_14", o = {
  label: i,
  error: d
}, f = ({
  children: e,
  labelText: t,
  id: r,
  className: c,
  containerClassName: n,
  error: a,
  ...b
}) => {
  const s = r ? `${r}-error` : void 0;
  return /* @__PURE__ */ m("div", { className: n, children: [
    /* @__PURE__ */ l(
      "label",
      {
        className: p(o.label, c),
        htmlFor: r,
        ...b,
        children: t
      }
    ),
    typeof e == "function" ? e({
      id: r,
      "data-testid": `${r}Input`,
      "aria-describedby": s
    }) : e,
    a && /* @__PURE__ */ l("div", { className: o.error, id: s, role: "alert", children: a })
  ] });
};
export {
  f as InputLabelWrapper
};
